export default __webpack_public_path__ + "static/FbTestimonial6-fe7092cc62b8fd112af912de86144efb.jpeg";